const actions = {
  PAYMENT_DATA_FETCH_BEGIN: 'PAYMENT_DATA_FETCH_BEGIN',
  PAYMENT_DATA_FETCH_SUCCESS: 'PAYMENT_DATA_FETCH_SUCCESS',
  PAYMENT_DATA_FETCH_ERR: 'PAYMENT_DATA_FETCH_ERR',

  paymentDataFetchBegin: () => ({
    type: actions.PAYMENT_DATA_FETCH_BEGIN,
  }),

  paymentDataFetchSuccess: (data) => ({
    type: actions.PAYMENT_DATA_FETCH_SUCCESS,
    data,
  }),

  paymentDataFetchErr: (err) => ({
    type: actions.PAYMENT_DATA_FETCH_ERR,
    err,
  }),
};

export const {
  PAYMENT_DATA_FETCH_BEGIN,
  PAYMENT_DATA_FETCH_SUCCESS,
  PAYMENT_DATA_FETCH_ERR,
  paymentDataFetchBegin,
  paymentDataFetchSuccess,
  paymentDataFetchErr,
} = actions;

export default actions;
